import React from 'react';
import AgreementDialog from './AgreementDialog';
import {useSelector} from 'react-redux';
import {selectAffiliateAgreement} from '../../selectors/eula.selectors';
import {Eula} from '../../reducers/eula.reducer';
import {RootState} from '../..';

interface Props {
    open: boolean;
    onClose: (event?) => void;
}

const AffiliateDialog: React.FunctionComponent<Props> = props => {
    const agreement = useSelector<RootState, Eula>(selectAffiliateAgreement);
    return <AgreementDialog eula={agreement} {...props} />;
};

export default React.memo(AffiliateDialog);
